import { AssetCache } from './cache.js';
import { MapRenderer } from './renderer.js';
import { LiveMapLoader } from './live-map-loader.js';
import { fetchJson } from './http.js';
import { logger } from './log.js';
import { mountMapEmbed } from './map-embed-controller.js';

const log = logger('MapEmbed');
const diagnostic = message => log.warn(message);
const preview = mountMapEmbed({
    canvas: document.getElementById('canvas'),
    status: document.getElementById('status'),
    retry: document.getElementById('map-embed-retry'),
    map: document.getElementById('viewer').dataset.map,
    onDiagnostic: diagnostic,
    createRenderer: () => new MapRenderer(document.getElementById('canvas'), diagnostic),
    createLoader: (renderer, onProgress, onFailure) => new LiveMapLoader({ renderer, cache: new AssetCache(diagnostic), onProgress, onFailure, onDiagnostic: diagnostic }),
    fetchDetails: (map, signal) => fetchJson(`/maps/${encodeURIComponent(map)}`, { signal, cache: 'no-cache' }),
});
window.addEventListener('pagehide', () => preview.dispose());
window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); });
